// BBB-517: Wales boundary polygon, used only to arbitrate the England/Wales
// bounding-box overlap in classifyPoint (see useViewportRegion.js). This is the
// whole country, unclipped — unlike SCOTLAND_BOUNDARY, which is clipped and
// carries a usage restriction.
//
// Simplification measurements, grid verification and the derivation of the
// border-proximity probe coordinates: docs/boundary-classification.md.
//
// SOURCE, LICENCE, RETRIEVAL
// Source: ONS Open Geography Portal, "Countries (December 2024) Boundaries UK
// BUC" (Ultra Generalised, 500m, clipped to coastline), Wales feature only.
//   https://open-geography-portalx-ons.hub.arcgis.com/datasets/ons::countries-december-2024-boundaries-uk-buc-2
// Retrieved 10/08/2026 directly from the underlying ArcGIS FeatureServer:
//   https://services1.arcgis.com/ESMARspQHYMw9BZ9/arcgis/rest/services/Countries_December_2024_Boundaries_UK_BUC/FeatureServer/0/query?where=CTRY24NM=%27Wales%27&outFields=CTRY24CD,CTRY24NM&outSR=4326&f=geojson
// CRITICAL: the request above MUST include `outSR=4326`. The Open Geography
// Portal's one-click "GeoJSON" download (and the FeatureServer's native
// spatial reference) serves coordinates in British National Grid
// (EPSG:27700), not WGS84, despite RFC 7946 requiring WGS84 for GeoJSON.
// Without outSR=4326 the coordinates are silently wrong against lng/lat map
// coordinates (Cardiff tests as NOT in Wales) — confirmed against a live
// classifyPoint run before this was caught. Verify any refetch by checking
// the returned lng/lat fall in plausible UK ranges (roughly lon -8.5 to 2,
// lat 49.8 to 61) before trusting it.
// Licence: Open Government Licence v3.0.
// Attribution (per https://www.ons.gov.uk/methodology/geography/licences):
// Contains OS data (c) Crown copyright and database right 2024. Contains ONS
// data (c) Crown copyright and database right 2024. Source: Office for
// National Statistics licensed under the Open Government Licence v3.0.
//
// That attribution is a licence obligation and was a comment only, on no screen
// anywhere, until the map credits were built. The rendered copy of it is
// ONS_OS_BOUNDARY_ATTRIBUTION in data/attributions.js, and attributions.test.js
// asserts the constant and this comment cannot drift apart. This header stays
// because it is the provenance record and carries the retrieval URLs; do not
// delete the string from it.
//
// Simplified with `mapshaper -simplify 50% keep-shapes`, 4dp rounding.
import WALES_BOUNDARY_GEOMETRY from './walesBoundary.json';

export const WALES_BOUNDARY = WALES_BOUNDARY_GEOMETRY;
